import fetch from "cross-fetch";
import { ApolloClient, ApolloLink, createHttpLink, InMemoryCache, NormalizedCacheObject } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { TokenManager } from '@amzn/fitjava-script-client';
import { tokenProviderInstance } from '../components/auth/token-provider';
import { logger } from "src/logger";
import { signOut } from "src/common/util";
import { TokenUtil } from "src/common/token-util";
// TEMPORARY (authgard dev stubs): dev-only mock link. Remove this import and the dev branch in
// getApolloClient — and delete dev-mock-link.ts — once the backend is live.
import { devMockLink } from "src/clients/dev-mock-link";

// Filled in from webpack
const graphQLEndpoint = 'https://api.fit.beta.aft.amazonoperations.app/graphql'

const authLink = setContext((request, previousContext) => {
    if (TokenUtil.isTokenExpired(TokenManager.getRefreshToken())) {
        logger.info("refresh_token has expired.");
        signOut();
    } else if (TokenUtil.isTokenExpired(TokenManager.getIdToken())) {
        logger.info("id_token has expired so refreshing it.")
        tokenProviderInstance.refreshToken();
    }
    return {
        headers: {
            "Fit-Authorization-Token": TokenManager.getIdToken()
        },
    };
});

const httpLink = createHttpLink({
    uri: graphQLEndpoint,
    fetch,
});

let client: ApolloClient<NormalizedCacheObject> | null = null;

/**
 * Gets the Apollo Client (singleton).
 */
export const getApolloClient = (): ApolloClient<NormalizedCacheObject> => {
    // Check if client not created yet
    if (!client) {
        // TEMPORARY (authgard dev stubs): in the dev server only, prepend devMockLink so the Authgard
        // operations are served locally (see dev-mock-link.ts). When the backend is live, delete that
        // file, drop its import above, and collapse this to `[authLink, httpLink]`.
        const links: ApolloLink[] = process.env.NODE_ENV === 'development'
            ? [devMockLink, authLink, httpLink]
            : [authLink, httpLink];
        // Create client
        client = new ApolloClient({
            link: ApolloLink.from(links),
            cache: new InMemoryCache()
        });
    }
    return client;
}